import axios from 'axios';
import store from '../index';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
const state = {
	items: [
		{
			_entity: '',
			_item: '',
			code: '',
			conditionType: '',
			country: '',
			createdDate: '',
			currency: '',
			ean: '',
			image: '',
			item: '',
			lastUpdatedDate: '',
			marketplace: '',
			operation: '',
			platform: '',
			price: 0,
			productType: '',
			qt: 0,
			qtunit: 1,
			sellerCurrency: '',
			sellerPrice: 0,
			sellerQt: 0,
			sellerSku: '',
			sku: '',
			status: '',
			url: '',
		},
	],
	item: [],
	index: '',
	sortBy: '',
	sortDesc: '',
};

const getters = {
	getItems: state => {
		return state.items;
	},
	getItem: state => {
		return state.item;
	},
	getIndex: state => {
		return state.index;
	},
	getSortBy: state => {
		return state.sortBy;
	},
	getSortDesc: state => {
		return state.sortDesc;
	},
};

const actions = {
	getDefaultCategoryTreeId: async (context, settings) => {
		let url = `ebay/taxonomy/get-default-category-tree-id/${settings.marketplace}`;

		//console.log(context.rootGetters['categories/getSortBy'])
		try {
			var res = await axios.get(
				`${context.rootGetters['settings/getUrl']}${url}`,

				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			);

			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	getCategorySuggestions: async (context, settings) => {
		let url = `ebay/taxonomy/get-category-suggestions/${settings.categoryID}/${settings.title}`;

		//console.log(context.rootGetters['categories/getSortBy'])
		try {
			var res = await axios.get(
				`${context.rootGetters['settings/getUrl']}${url}`,

				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			);

			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	getItemAspectsForCategory: async (context, settings) => {
		let url = `ebay/taxonomy/get-item-aspects-for-category/${settings.categoryTreeId}/${settings.categoryId}`;

		//console.log(context.rootGetters['categories/getSortBy'])
		try {
			var res = await axios.get(
				`${context.rootGetters['settings/getUrl']}${url}`,

				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			);

			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	getCategorySubtree: async (context, settings) => {
		let url = `ebay/taxonomy/get-category-subtree/${settings.categoryTreeId}/${settings.categoryId}`;

		try {
			var res = await axios.get(
				`${context.rootGetters['settings/getUrl']}${url}`,

				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			);

			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	getFulfillmentPolicies: async (context, settings) => {
		let url = `ebay/account/get-fulfillment-policies/${settings.marketplace}`;

		try {
			const res = await axios.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			});

			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	getPaymentPolicies: async (context, settings) => {
		let url = `ebay/account/get-payment-policies/${settings.marketplace}`;

		try {
			const res = await axios.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			});

			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	getReturnPolicies: async (context, settings) => {
		let url = `ebay/account/get-return-policies/${settings.marketplace}`;

		try {
			const res = await axios.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			});

			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	getInventoryLocations: async context => {
		let url = 'ebay/inventory/get-inventory-locations';

		try {
			const res = await axios.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			});

			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	// Modifica del CMS marketplace per le inserzioni Trading API (senza offerta Inventory API):
	// prezzo e quantita' con ReviseInventoryStatus. L'inserzione la legge il backend dal prodotto.
	reviseTradingListing: async (context, { itemId, entityId, price, quantity }) => {
		const res = await axios.post(
			`${context.rootGetters['settings/getUrl']}ebay/trading/revise-inventory-status`,
			{ itemId, entityId, price, quantity },
			{
				headers: {
					Authorization: `Bearer ${context.rootGetters['profile/getToken']}`,
					'Content-Type': 'application/json',
				},
			},
		);
		return res.data;
	},
	getOffers: async (context, settings = {}) => {
		const params = new URLSearchParams();
		Object.entries(settings || {}).forEach(([key, value]) => {
			if (value !== undefined && value !== null && value !== '') {
				params.append(key, value);
			}
		});
		const query = params.toString();
		const url = `ebay/inventory/get-offers${query ? `?${query}` : ''}`;

		try {
			const res = await axios.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: {
					Authorization: `Bearer ${context.rootGetters['profile/getToken']}`,
					'Content-Type': 'application/json',
				},
			});

			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
			throw err;
		}
	},
	getOffer: async (context, settings) => {
		const params = new URLSearchParams();
		if (settings.headers && Object.keys(settings.headers).length > 0) {
			params.append('headers', JSON.stringify(settings.headers));
		}
		const query = params.toString();
		const url = `ebay/inventory/get-offer/${encodeURIComponent(settings.offerId)}${query ? `?${query}` : ''}`;
		const headers = {
			Authorization: `Bearer ${context.rootGetters['profile/getToken']}`,
			'Content-Type': 'application/json',
		};

		try {
			const res = await axios.get(`${context.rootGetters['settings/getUrl']}${url}`, { headers });

			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
			throw err;
		}
	},
	updateOffer: async (context, settings) => {
		const url = `ebay/inventory/update-offer/${encodeURIComponent(settings.offerId)}`;
		const body = {
			...(settings.payload || {}),
			headers: settings.headers || {},
		};
		const headers = {
			Authorization: `Bearer ${context.rootGetters['profile/getToken']}`,
			'Content-Type': 'application/json',
		};

		try {
			const res = await axios.put(`${context.rootGetters['settings/getUrl']}${url}`, body, { headers });

			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
			throw err;
		}
	},
	getInventoryItem: async (context, settings) => {
		const params = new URLSearchParams();
		if (settings.headers && Object.keys(settings.headers).length > 0) {
			params.append('headers', JSON.stringify(settings.headers));
		}
		const query = params.toString();
		const url = `ebay/inventory/get-inventory-item/${encodeURIComponent(settings.sku)}${query ? `?${query}` : ''}`;
		const headers = {
			Authorization: `Bearer ${context.rootGetters['profile/getToken']}`,
			'Content-Type': 'application/json',
		};

		try {
			const res = await axios.get(`${context.rootGetters['settings/getUrl']}${url}`, { headers });

			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
			throw err;
		}
	},
	createOrReplaceInventoryItem: async (context, settings) => {
		const url = `ebay/inventory/create-or-replace-inventory-item/${encodeURIComponent(settings.sku)}`;
		const body = {
			...(settings.payload || {}),
			headers: settings.headers || {},
		};
		const headers = {
			Authorization: `Bearer ${context.rootGetters['profile/getToken']}`,
			'Content-Type': 'application/json',
		};

		try {
			const res = await axios.put(`${context.rootGetters['settings/getUrl']}${url}`, body, { headers });

			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
			throw err;
		}
	},
	withdrawOffer: async (context, settings) => {
		const url = `ebay/inventory/withdraw-offer/${encodeURIComponent(settings.offerId)}`;

		try {
			const res = await axios.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{},
				{
					headers: {
						Authorization: `Bearer ${context.rootGetters['profile/getToken']}`,
						'Content-Type': 'application/json',
					},
				},
			);

			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
			throw err;
		}
	},
	deleteOffer: async (context, settings) => {
		const url = `ebay/inventory/delete-offer/${encodeURIComponent(settings.offerId)}`;

		try {
			const res = await axios.delete(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: {
					Authorization: `Bearer ${context.rootGetters['profile/getToken']}`,
					'Content-Type': 'application/json',
				},
			});

			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
			throw err;
		}
	},
	deleteInventoryItem: async (context, settings) => {
		const url = `ebay/inventory/delete-inventory-item/${encodeURIComponent(settings.sku)}`;

		try {
			const res = await axios.delete(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: {
					Authorization: `Bearer ${context.rootGetters['profile/getToken']}`,
					'Content-Type': 'application/json',
				},
			});

			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
			throw err;
		}
	},
	createInventoryLocation: async (context, settings) => {
		const url = `ebay/inventory/create-inventory-location/${encodeURIComponent(settings.merchantLocationKey)}`;
		const headers = {
			Authorization: `Bearer ${context.rootGetters['profile/getToken']}`,
			'Content-Type': 'application/json',
		};

		const body = {
			...settings.payload,
			headers: settings.headers || {},
		};

		try {
			const res = await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, body, { headers });
			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
			throw err;
		}
	},
	publishListing: async (context, settings) => {
		const baseUrl = context.rootGetters['settings/getUrl'];
		const headers = {
			Authorization: `Bearer ${context.rootGetters['profile/getToken']}`,
			'Content-Type': 'application/json',
		};

		const inventoryUrl = `ebay/inventory/create-or-replace-inventory-item/${encodeURIComponent(settings.sku)}`;
		const offerUrl = 'ebay/inventory/create-offer';
		const inventoryBody = {
			...settings.inventoryPayload,
			headers: settings.inventoryHeaders || {},
		};
		const offerBody = {
			...settings.offerPayload,
			headers: settings.offerHeaders || {},
		};

		let inventoryResponse;
		try {
			inventoryResponse = await axios.put(`${baseUrl}${inventoryUrl}`, inventoryBody, { headers });
		} catch (error) {
			error.publishStage = 'createOrReplaceInventoryItem';
			throw error;
		}
		let offerResponse;
		let offerId;

		try {
			offerResponse = await axios.post(`${baseUrl}${offerUrl}`, offerBody, { headers });
			offerId = offerResponse?.data?.offerId;
		} catch (error) {
			const ebayErrors = error?.response?.data?.error?.errors || [];
			const existingOfferError = ebayErrors.find(item => item?.errorId === 25002);
			const existingOfferId = existingOfferError?.parameters?.find(parameter => parameter?.name === 'offerId')?.value;

			if (!existingOfferId) {
				error.publishStage = 'createOffer';
				throw error;
			}

			const updateOfferUrl = `ebay/inventory/update-offer/${encodeURIComponent(existingOfferId)}`;
			try {
				await axios.put(`${baseUrl}${updateOfferUrl}`, offerBody, { headers });
			} catch (updateError) {
				updateError.publishStage = 'updateOffer';
				throw updateError;
			}
			offerResponse = { data: { offerId: existingOfferId, reusedExistingOffer: true } };
			offerId = existingOfferId;
		}

		if (!offerId) {
			throw new Error('offerId not returned by eBay');
		}

		const publishUrl = `ebay/inventory/publish-offer/${encodeURIComponent(offerId)}`;
		let publishResponse;
		try {
			publishResponse = await axios.post(`${baseUrl}${publishUrl}`, {}, { headers });
		} catch (error) {
			error.publishStage = 'publishOffer';
			throw error;
		}

		return {
			inventory: inventoryResponse.data,
			offer: offerResponse.data,
			offerId,
			publish: publishResponse.data,
		};
	},
	asyncFetchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		let url = 'items/ebay';

		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);

		//console.log(context.rootGetters['categories/getSortBy'])
		try {
			var res = await axios.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: context.rootGetters['ebay/getSortBy'],
						sortDesc: context.rootGetters['ebay/getSortDesc'],
						page: page,
						itemsPerPage: itemsPerPage,
						filters: settings.filters ? settings.filters : '',
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			);
			await context.commit('setItems', res.data.data);
			return res.data.pagination;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	updateData: async (context, settings) => {
		let url = 'items/ebay';

		//console.log(context.rootGetters['categories/getSortBy'])
		try {
			var res = await axios.put(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						...settings,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			);

			return res.data;
		} catch (err) {
			console.log('errore', err);
			console.log('message', err.message);
			console.log('stack', err.stack);
		}
	},
	asyncSearchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		let url = 'items/amazon';

		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);
		//console.log(context.rootGetters['categories/getSortBy'])
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: context.rootGetters['items/getSortBy'],
						sortDesc: context.rootGetters['items/getSortDesc'],
						page: page,
						itemsPerPage: itemsPerPage,
						filters: settings.filters ? settings.filters : '',
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				return res.data.data;

				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
			});
	},

	deleteItems: async (context, settings) => {
		let url = 'items/delete';
		//console.log(context.rootGetters['categories/getSortBy'])
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						query: settings,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)
			.then(res => {
				//console.log(res.data.pagination);
				//context.commit('setCategories', res.data.data);
				return res.data;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err.response.status);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }*/
				return { error: err.response.status };
				//throw Error(err.response.status);
			});
	},

	destroyData: context => {
		context.commit('setItems', []);
		context.commit('setItem', []);
		context.commit('setIndex', '');
	},

	searchProducts: async (context, payload) => {
		let url = 'items';

		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: payload.settings.sortBy,
						sortDesc: payload.settings.sortDesc,
						page: payload.settings.page,
						itemsPerPage: payload.settings.itemsPerPage,
						filters: payload.settings.filters ? payload.settings.filters : '',
						search: payload.settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				return res.data.data;
			})
			.catch(err => {
				console.log('errore', err);
			});
	},
};

const mutations = {
	setItems: async (state, value) => {
		state.items = value;
	},
	setItem: (state, value) => {
		state.item = value;
	},
	setSortBy: (state, value) => {
		state.sortBy = value;
	},
	setIndex: (state, value) => {
		state.index = value;
	},
	setSortDesc: (state, value) => {
		state.sortDesc = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
